<template>
  <div class="addevent container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">Create An Event</h4>
              </div>
            </div>
          </div>
          <div class="createeventCard">
            <b-tabs class="evnetTypesTabs">
              <b-tab
                title="Class"
                active
                title-link-class="btn btn-bumblebee btn-doomyoga btn-tab btn-doomyoga-secondary"
              >
                <EventInfo
                  client_name="DY"
                  field_name="class"
                  event_type="class"
                  action="create"
                  :locations="locations"
                />
              </b-tab>
              <b-tab
                title="Course"
                title-link-class="btn btn-bumblebee btn-doomyoga btn-tab btn-doomyoga-secondary"
              >
                <EventInfo
                  client_name="DY"
                  field_name="course"
                  event_type="course"
                  action="create"
                  :locations="locations"
                />
                <!-- <EventCourseInfo  action="create"/> -->
              </b-tab>
              <b-tab
                title="Private Class"
                title-link-class="btn btn-bumblebee btn-doomyoga btn-tab btn-doomyoga-secondary"
                ><EventPrivateClassInfo action="create" :locations="locations"
              /></b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventInfo from "@/components/events/EventInfo.vue";
import EventClass from "./AddClass";
import EventCourseInfo from "./CourseInfo.vue";
// import EventCourse from "./AddCourse.vue";
// import EventPrivateClass from "./AddPrivateClass.vue";
import EventPrivateClassInfo from "./PrivateClassInfo.vue";

export default {
  name: "AddEvent",
  components: { EventInfo, EventCourseInfo, EventPrivateClassInfo },
  data() {
    return {
      locations: [
        { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
        { text: "Kimberley Street, London", id: "Kimberley Street, London" },
        { text: "Dublin, Ireland", id: "Dublin, Ireland" },
        { text: "Studio Doom Yoga, London", id: "Studio Doom Yoga, London" },
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/events/AddEvent.vue